class DotPadLine {
    constructor(lineId, requestTime, numberCellColumns) {
        this.lineId = lineId;
        this.startCellIndex = 0;
        this.sendData = "";
        this.seqNum = "00";
        this.lineData = "00".repeat(numberCellColumns);
        this.requestReady = false;
        this.requestTime = requestTime;
        this.receiveAck = true;
        this.numberCellColumns = numberCellColumns;

        this.refreshLiveData = "";
        this.refreshLiveStartCellIndex = 0;
    }

    getSendData() {
        return this.sendData;
    }

    getLineId() {
        return this.lineId;
    }

    getRequestReady() {
        return this.requestReady;
    }

    getReceiveAck() {
        return this.receiveAck;
    }

    setReceiveAck(receiveAck) {
        this.receiveAck = receiveAck;
    }

    setRequestReady(requestReady){
        this.requestReady = requestReady;
    }

    getRequestTime() {
        return this.requestTime;
    }

    getStartCellIndex() {
        return this.startCellIndex
    }

    getSeqNum() {
        return this.seqNum
    }

    refresh(mode = "ALL_DISPLAY") {
        this.requestReady = true;
        this.receiveAck = true;

        // 라인 갱신
        if (mode == "LIVE_DISPLAY") {
            this.sendData = this.refreshLiveData;
            this.startCellIndex = this.refreshLiveStartCellIndex;
        } else {
            this.sendData = this.lineData;
            this.startCellIndex = 0;
        }
    }

    initRefreshLiveData(startCellIndex, sendData) {
        this.refreshLiveData = sendData;
        this.refreshLiveStartCellIndex = startCellIndex;
    }
    
    setRefreshLiveData(startCellIndex, sendData) {
        const result = this.getMergeCellData(
            this.refreshLiveData,
            this.refreshLiveStartCellIndex,
            sendData,
            startCellIndex
        );
    
        this.refreshLiveData = result.sendData;
        this.refreshLiveStartCellIndex = result.startCellIndex;
    }

    setSendStatus() {
        this.requestReady = false
        this.receiveAck = false
    }

    setCommand(seqNum, startCellIndex, sendData) {
        this.seqNum = seqNum;

        // 발송이 끝난상태면 새로세팅
        if (!this.requestReady && this.receiveAck) {
            this.startCellIndex = startCellIndex;
            this.sendData = sendData;
        } else {
            // 아닐경우
            const result = this.getMergeCellData(this.sendData, this.startCellIndex, sendData, startCellIndex);

            this.sendData = result.sendData;
            this.startCellIndex = result.startCellIndex;
        }

        this.requestReady = true;
        this.receiveAck = true;

        this.setLineData();
    }

    getMergeCellData(baseSendData, baseStartCellIndex, sendData, startCellIndex) {
        var returnData = "";
        var returnStartCellIndex = 0;

        if (baseSendData == "") {
            return {sendData: sendData, startCellIndex: startCellIndex};
        }
        
        // 새로등록된 시작셀이 앞일 경우
        if (baseStartCellIndex >= startCellIndex) {
            const temp = baseStartCellIndex - startCellIndex;

            // 기존데이터가 신규데이터와 겹칠경우
            if (temp * 2 < sendData.length) {
                // 시작셀 차이 만큼 00 채우기(시작셀을 같게 만들어줌)
                const tempData = "00".repeat(temp) + baseSendData;

                // 데이터 길이 비교후 데이터 세팅(신규데이터의 길이 > 시작셀이 동일한 기존데이터의 길이)
                // 새 데이터가 길경우 덮어쓰기 : 기존 데이터가 길경우 새 데이터 부분만큼만 덮어쓰기
                returnData = sendData.length >= tempData.length ? sendData : sendData + tempData.substring(sendData.length);
            } else {
                // 겹치지 않을경우
                const originData = this.lineData.substring(startCellIndex * 2 + sendData.length, baseStartCellIndex * 2);
                returnData = sendData + originData + baseSendData;
            }

            // 시작셀 세팅
            returnStartCellIndex = startCellIndex;
        } else {
            // 기존등록된 시작셀이 앞일 경우
            returnStartCellIndex = baseStartCellIndex;

            // 시작셀 차이 만큼 기존 데이터로 채우기
            const temp = startCellIndex - baseStartCellIndex;

            // 기존데이터가 신규데이터와 겹칠경우
            if (temp * 2 < baseSendData.length) {
                // 겹치지 않는 앞부분 + 신규데이터
                const tempData = baseSendData.substring(0, temp * 2) + sendData;

                // 데이터 길이 비교후 데이터 세팅
                // 새 데이터가 길경우 덮어쓰기 : 기존 데이터가 길경우 새 데이터 뒤에 기존데이터를 붙이기
                returnData = tempData.length >= baseSendData.length ? tempData : tempData + baseSendData.substring(tempData.length);
            } else {
                // 기존데이터가 신규데이터와 겹치지 않을경우 데이터 사이에 원래 출력된 데이터로 채우기
                const originData = this.lineData.substring(baseStartCellIndex * 2, startCellIndex * 2);
                returnData = originData + sendData;
            }
        }

        return { sendData: returnData, startCellIndex: returnStartCellIndex };
    }

    setLineData() {
        let tempFront = this.lineData.substring(0, this.startCellIndex * 2) + this.sendData;
        this.lineData = tempFront + this.lineData.substring(tempFront.length);

        const remainingLength = this.numberCellColumns * 2 - this.lineData.length;
        if (remainingLength > 0) {
            this.lineData += "00".repeat(remainingLength);
        }
    }

    getLineData() {
        return this.lineData
    }
}

export {
    DotPadLine
}
